<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Вход в WikiBase</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="form.username"
                label="Имя пользователя"
                name="username"
                prepend-icon="mdi-account"
                type="text"
                required
              />

              <v-text-field
                v-model="form.password"
                label="Пароль"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="login"
              :loading="apiStore.loading"
            >
              Войти
            </v-btn>
          </v-card-actions>
          <v-card-text class="text-center">
            <router-link to="/register">Нет аккаунта? Зарегистрироваться</router-link>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar = false">
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script setup lang="ts">
// @ts-nocheck
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useApiStore } from '@/stores/api'
import { useTenantStore } from '@/stores/tenant'

const router = useRouter()
const apiStore = useApiStore()
const tenantStore = useTenantStore()

const form = ref({
  username: '',
  password: ''
})

const snackbar = ref(false)
const snackbarText = ref('')
const snackbarColor = ref('success')

const login = async () => {
  if (!form.value.username || !form.value.password) {
    showSnackbar('Заполните все поля', 'error')
    return
  }

  try {
    await apiStore.login(form.value.username, form.value.password)
    
    // Инициализируем tenant store после успешного логина
    await tenantStore.initStore()
    
    showSnackbar('Успешный вход!', 'success')
    router.push('/')
  } catch (error: any) {
    console.error('Login error:', error)
    const message = apiStore.error || 'Ошибка входа'
    showSnackbar(message, 'error')
  }
}

const showSnackbar = (text: string, color: string) => {
  snackbarText.value = text
  snackbarColor.value = color
  snackbar.value = true
}
</script>
